export default __webpack_public_path__ + "static/media/532.d14d5c63.jpg";